module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sticky"
  }, [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "header-item"
  }, [_c('span', {
    staticClass: "fa fa-fw fa-building"
  }), _vm._v(" "), _c('strong', [_vm._v("View by")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "value": null
    },
    model: {
      value: (_vm.currentFilter),
      callback: function($$v) {
        _vm.currentFilter = $$v
      },
      expression: "currentFilter"
    }
  }, _vm._l(([{
    option: 'Station'
  }, {
    option: 'Show'
  }]), function(type, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": type.option,
        "value": type.option
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.selectedFilter === 'Show') ? _c('div', {
    staticClass: "header-item"
  }, [_c('span', {
    staticClass: "fa fa-fw fa-clock-o"
  }), _vm._v(" "), _c('strong', [_vm._v("Show |")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "value": null
    },
    model: {
      value: (_vm.selectedTimeslot),
      callback: function($$v) {
        _vm.selectedTimeslot = $$v
      },
      expression: "selectedTimeslot"
    }
  }, _vm._l((_vm.timeslots), function(slot) {
    return _c('el-option', {
      key: slot.id,
      attrs: {
        "label": slot.title,
        "value": slot.id
      }
    })
  }), 1)], 1) : _vm._e()])]), _vm._v(" "), (_vm.filtersLoading) ? _c('div', {
    staticClass: "dashboard-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('loader', {
    attrs: {
      "message": _vm.loadingMessage
    }
  })], 1)])]) : _c('div', {
    staticClass: "dashboard-content"
  }, [_c('div', {
    staticClass: "unit-block-row"
  }, [_c('div', {
    staticClass: "row row-1"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedProgrammingDate, 'dddd Do'),
      "unit": 'Day',
      "unitClass": 'label-info',
      "description": 'Received',
      "selected": _vm.selectedProgrammingPeriod === 'day',
      "received": _vm.chartsData['day-stats'].total,
      "growth": _vm.chartsData['day-stats'].growth,
      "stats": _vm.chartsData['day-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'day'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'day'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changePeriod('day')
      }
    }
  }, [(!Boolean(_vm.chartsData['day-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock',
      "contentVisible": _vm.showNoContent
    },
    on: {
      "onNoContent": _vm.handleNoContent
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedProgrammingDate, 'YYYY [Week] WW'),
      "unit": 'Week',
      "unitClass": 'label-success',
      "description": 'Received',
      "selected": _vm.selectedProgrammingPeriod === 'week',
      "received": _vm.chartsData['week-stats'].total,
      "growth": _vm.chartsData['week-stats'].growth,
      "stats": _vm.chartsData['week-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'week'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'week'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changePeriod('week')
      }
    }
  }, [(!Boolean(_vm.chartsData['week-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedProgrammingDate, 'MMMM'),
      "unit": 'Month',
      "unitClass": 'label-primary',
      "description": 'Received',
      "selected": _vm.selectedProgrammingPeriod === 'month',
      "received": _vm.chartsData['month-stats'].total,
      "growth": _vm.chartsData['month-stats'].growth,
      "stats": _vm.chartsData['month-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'month'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'month'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changePeriod('month')
      }
    }
  }, [_c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedProgrammingDate, 'YYYY'),
      "unit": 'Year',
      "unitClass": 'label-danger',
      "description": 'Received',
      "selected": _vm.selectedProgrammingPeriod === 'year',
      "received": _vm.chartsData['year-stats'].total,
      "growth": _vm.chartsData['year-stats'].growth,
      "stats": _vm.chartsData['year-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'year'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'year'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changePeriod('year')
      }
    }
  }, [(!Boolean(_vm.chartsData['year-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row row-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('programming-dashboard-unit', {
    attrs: {
      "title": "Messages",
      "titleIconClass": "fa fa-fw fa-envelope-o",
      "height": "280px",
      "titleRightIcon": {
        icon: 'fa fa-info-circle',
        tooltip: 'Click to view more info about messages',
      }
    },
    on: {
      "unitRightIconClick": _vm.messagesUnitRightIconClick
    }
  }, [(_vm.messagesData.total) ? _c('div', {
    attrs: {
      "slot": "unit-content"
    },
    slot: "unit-content"
  }, [_c('horizontal-bar-chart', {
    staticStyle: {
      "max-height": "120px",
      "min-height": "120px"
    },
    attrs: {
      "showYAxes": true,
      "showXAxes": false,
      "data": _vm.sortMessagesChartData
    }
  })], 1) : _vm._e(), _vm._v(" "), (!Boolean(_vm.messagesData.total)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'ProgrammingDashboardUnitLoader'
    },
    slot: "unit-content"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-dialog', {
    attrs: {
      "title": "Competitions",
      "visible": _vm.promotionsDialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.promotionsDialogVisible = $event
      }
    }
  }, [(_vm.loadingAudienceData) ? _c('loader', {
    attrs: {
      "message": 'Loading...'
    }
  }) : _c('promotions-table', {
    attrs: {
      "data": _vm.promotionsData
    }
  })], 1), _vm._v(" "), _c('programming-dashboard-unit', {
    attrs: {
      "title": "Competitions",
      "titleIconClass": "fa fa-fw fa-gift",
      "height": "280px",
      "titleRightIcon": {
        icon: 'fa fa-info-circle',
        tooltip: 'Click to view Competitions table report',
      }
    },
    on: {
      "unitRightIconClick": _vm.promotionsUnitRightIconClick
    }
  }, [(_vm.promotionsData.length) ? _c('div', {
    attrs: {
      "slot": "unit-content"
    },
    slot: "unit-content"
  }, [_c('horizontal-bar-chart', {
    staticStyle: {
      "max-height": "180px",
      "min-height": "180px",
      "overflow-y": "scroll"
    },
    attrs: {
      "height": _vm.promotionBarChartHeight,
      "showYAxes": true,
      "showXAxes": false,
      "data": _vm.promotionsData.map(function (p) { return [
        _vm.getPromotionLabel(p.name),
        {
          Entries: p.entries,
          Uniques: p.uniques
        } ]; })
    }
  })], 1) : _vm._e(), _vm._v(" "), (!Boolean(Object.keys(_vm.promotionsData).length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'ProgrammingDashboardUnitLoader',
      "contentVisible": _vm.showNoContent
    },
    on: {
      "onNoContent": _vm.handleNoContent
    },
    slot: "unit-content"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": 237
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', {
    staticClass: "unit-title"
  }, [_c('span', {
    staticClass: "fa fa-fw fa-calendar"
  }), _vm._v("Heat Map\n            ")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.chartsData['heat-map-stats'].points)) ? _c('analytics-heat-map', {
    attrs: {
      "data": _vm.chartsData['heat-map-stats'].points,
      "range": _vm.chartsData['heat-map-stats'].range
    },
    on: {
      "onChangeDate": function($event) {
        return _vm.$emit('onHeatMapDateChange', $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.chartsData['heat-map-stats'].points)) ? _c('content-loader-placeholder', {
    attrs: {
      "type": 'AnalyticsHeatMapLoader'
    }
  }) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row-3"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', {
    staticClass: "chart-title"
  }, [_c('i', {
    staticClass: "fa fa-area-chart"
  }), _vm._v(" "), _c('strong', [_vm._v("Engagement")])]), _vm._v(" "), _c('div', {
    staticClass: "chart-filters pull-right"
  }, [_c('label', {
    staticClass: "label label-primary chart-label",
    class: {
      active: _vm.selectedEngagementsFilter === 'timeslot'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeFilter', {
          filter: 'timeslot'
        })
      }
    }
  }, [_vm._v("Timeslots")]), _vm._v(" "), _c('label', {
    staticClass: "label label-primary chart-label",
    class: {
      active: _vm.selectedEngagementsFilter === 'channel'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeFilter', {
          filter: 'channel'
        })
      }
    }
  }, [_vm._v("Channels")]), _vm._v(" "), _c('label', {
    staticClass: "label label-primary chart-label",
    class: {
      active: _vm.selectedEngagementsFilter === 'campaign'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeFilter', {
          filter: 'campaign'
        })
      }
    }
  }, [_vm._v("Campaigns")])])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.mainChartData.stats.points.length)) ? _c('analytics-time-series-area-chart', {
    attrs: {
      "data": _vm.mainChartData.stats.points,
      "unit": _vm.units[_vm.units.indexOf(_vm.selectedProgrammingPeriod) - 1],
      "showLegend": false
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.mainChartData.stats.points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'EngagementGraphLoader'
    },
    slot: "unit-content"
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('programming-dashboard-unit', {
    attrs: {
      "title": "Topics Trending",
      "titleIconClass": "fa fa-fw fa-star"
    }
  }, [(_vm.trendingTopics.length) ? _c('vue-word-cloud', {
    staticStyle: {
      "width": "100%",
      "min-height": "465px",
      "display": "block"
    },
    attrs: {
      "slot": "unit-content",
      "font-family": "'Helvetica Neue', sans-serif",
      "rotationUnit": "turn",
      "color": _vm.trendingWordColor,
      "rotation": _vm.trendingWordsRotation,
      "animationDuration": 1500,
      "spacing": 0.3,
      "words": _vm.trendingTopics
    },
    slot: "unit-content"
  }) : _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'WordCloudLoader'
    },
    slot: "unit-content"
  })], 1)], 1)]), _vm._v(" "), (_vm.isStreaming) ? _c('div', {
    staticClass: "row row-4"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('programming-dashboard-unit', {
    attrs: {
      "height": "570px",
      "title": "Streaming Load",
      "titleIconClass": "fa fa-fw fa-area-chart"
    }
  }, [_c('div', {
    attrs: {
      "slot": "unit-content"
    },
    slot: "unit-content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingStreamingData),
      expression: "loadingStreamingData"
    }],
    staticClass: "col-lg-8"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.onChangeStreamingFilter
    },
    model: {
      value: (_vm.streamingFilter),
      callback: function($$v) {
        _vm.streamingFilter = $$v
      },
      expression: "streamingFilter"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Full week",
      "name": "week"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Week day",
      "name": "weekday"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Saturday",
      "name": "saturday"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Sunday",
      "name": "sunday"
    }
  })], 1), _vm._v(" "), _c('streaming-load', {
    attrs: {
      "showLegend": true,
      "showGridLines": true,
      "periodLabel": _vm.streamingPeriodLabel,
      "isTrimesterComplete": _vm.isTrimesterComplete,
      "data": _vm.prepareStreamingGraphData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('streaming-overview-table', {
    attrs: {
      "avgData": _vm.streamingData,
      "selectedPeriod": _vm.getStreamingOverviewPeriod
    }
  })], 1)])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row row-5"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('programming-dashboard-unit', {
    attrs: {
      "title": "Commercial Load",
      "titleIconClass": "fa fa-fw fa-bullhorn",
      "height": "580px"
    }
  }, [(_vm.commercialLoadData.length) ? _c('div', {
    attrs: {
      "slot": "unit-content"
    },
    slot: "unit-content"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('label', [_vm._v("Compare with Station  ")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.currentStation),
      callback: function($$v) {
        _vm.currentStation = $$v
      },
      expression: "currentStation"
    }
  }, _vm._l((_vm.stations), function(station) {
    return _c('el-option', {
      key: station.id,
      attrs: {
        "label": station.title,
        "value": station.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('playout-load', {
    attrs: {
      "showLegend": true,
      "station": _vm.stationName,
      "comparedStaton": _vm.selectedComparedStation,
      "data": _vm.commercialLoadData,
      "showGridLines": true,
      "yAxeslabelString": "Seconds",
      "xAxeslabelString": "Hour",
      "title": "commercial"
    }
  })], 1) : _c('blurred-image-place-holder', {
    attrs: {
      "slot": "unit-content",
      "showContactSales": true,
      "height": "500px",
      "imageSrc": '/static/assets/images/analytics/comercial-load-unblured.png',
      "alt": 'Comercial load blured image'
    },
    slot: "unit-content"
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('programming-dashboard-unit', {
    attrs: {
      "title": "Content Threads",
      "titleIconClass": "fa fa-fw fa-file-text-o",
      "height": "580px"
    }
  }, [(_vm.contentThreads.length) ? _c('content-threads-table', {
    attrs: {
      "slot": "unit-content",
      "data": _vm.contentThreads,
      "limit": 12
    },
    slot: "unit-content"
  }) : _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'ListDividerLoader'
    },
    slot: "unit-content"
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row-6"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('programming-dashboard-unit', {
    attrs: {
      "title": "Musical Load",
      "titleIconClass": "fa fa-fw fa-bullhorn"
    }
  }, [(_vm.musicalLoadData.length) ? _c('div', {
    attrs: {
      "slot": "unit-content"
    },
    slot: "unit-content"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('label', [_vm._v("Compare with Station  ")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.currentStation),
      callback: function($$v) {
        _vm.currentStation = $$v
      },
      expression: "currentStation"
    }
  }, _vm._l((_vm.stations), function(station) {
    return _c('el-option', {
      key: station.id,
      attrs: {
        "label": station.title,
        "value": station.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('playout-load', {
    attrs: {
      "showLegend": true,
      "showGridLines": true,
      "station": _vm.stationName,
      "comparedStaton": _vm.selectedComparedStation,
      "data": _vm.musicalLoadData,
      "yAxeslabelString": "No. of songs",
      "xAxeslabelString": "Hour",
      "title": "music"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row top-track"
  }, [_c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 ours"
  }, [_c('h3', [_vm._v(_vm._s(_vm.stationName))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('h3', [_vm._v("-")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 theirs"
  }, [_c('h3', [_vm._v(_vm._s(_vm.selectedComparedStation))])])]), _vm._v(" "), _vm._l((10), function(i) {
    return _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "row top-track"
    }, [_c('div', {
      staticClass: "col-md-1"
    }, [_c('div', {
      staticClass: "count"
    }, [_vm._v(_vm._s(i))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-5 ours"
    }, [(
      _vm.topTracksData.length > 0 &&
      _vm.topTracksData[0].length >= i &&
      _vm.topTracksData[0][i - 1].hasOwnProperty('artist')
    ) ? _c('span', {
      staticClass: "artist"
    }, [_vm._v(_vm._s(_vm.topTracksData[0][i - 1].artist))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (
      _vm.topTracksData.length > 0 &&
      _vm.topTracksData[0].length >= i &&
      _vm.topTracksData[0][i - 1].hasOwnProperty('title')
    ) ? _c('span', {
      staticClass: "track"
    }, [_vm._v(_vm._s(_vm.topTracksData[0][i - 1].title))]) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": "Number of times song played",
        "placement": "bottom"
      }
    }, [(
      _vm.topTracksData.length > 1 &&
      _vm.topTracksData[0].length >= i &&
      _vm.topTracksData[0][i - 1].hasOwnProperty('artist')
    ) ? _c('span', {
      staticClass: "label pull-right"
    }, [_vm._v(_vm._s(_vm.topTracksData[0][i - 1].count))]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-1 status"
    }, [_c('growth', {
      attrs: {
        "is-percentage": false,
        "value": 0
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-5 theirs"
    }, [(
      _vm.topTracksData.length > 1 &&
      _vm.topTracksData[1].length >= i &&
      _vm.topTracksData[1][i - 1].hasOwnProperty('artist')
    ) ? _c('span', {
      staticClass: "artist"
    }, [_vm._v(_vm._s(_vm.topTracksData[1][i - 1].artist))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (
      _vm.topTracksData.length > 1 &&
      _vm.topTracksData[1].length >= i &&
      _vm.topTracksData[1][i - 1].hasOwnProperty('artist')
    ) ? _c('span', {
      staticClass: "track"
    }, [_vm._v(_vm._s(_vm.topTracksData[1][i - 1].title))]) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": "Number of times song played",
        "placement": "bottom"
      }
    }, [(
      _vm.topTracksData.length > 1 &&
      _vm.topTracksData[1].length >= i &&
      _vm.topTracksData[1][i - 1].hasOwnProperty('artist')
    ) ? _c('span', {
      staticClass: "label pull-left"
    }, [_vm._v(_vm._s(_vm.topTracksData[1][i - 1].count))]) : _vm._e()])], 1)])])
  })], 2)])]) : _c('blurred-image-place-holder', {
    attrs: {
      "slot": "unit-content",
      "showContactSales": true,
      "imageSrc": '/static/assets/images/analytics/musical-load-unblured.png',
      "alt": 'Musical load blured image'
    },
    slot: "unit-content"
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('programming-dashboard-unit', {
    attrs: {
      "title": "Audience Profile",
      "titleIconClass": "fa fa-fw fa-user-o"
    }
  }, [(_vm.loadingAudienceData) ? _c('content-placeholder', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5%"
    },
    attrs: {
      "slot": "unit-content",
      "text-value": "Loading...",
      "text-only": true,
      "count": 1
    },
    slot: "unit-content"
  }) : (Object.keys(_vm.audienceProfileData).length) ? _c('div', {
    attrs: {
      "slot": "unit-content"
    },
    slot: "unit-content"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 audience-title"
  }, [_vm._v(_vm._s(_vm.getTimeslotLabel))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 audience-title"
  }, [_vm._v("ALL PROFILES")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 audience-title"
  }, [_vm._v("STATION AUDIENCE")])]), _vm._v(" "), _vm._l((Object.keys(_vm.audienceProfileData)), function(demographic) {
    return _c('div', {
      key: demographic,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-2 vertical-text"
    }, [_vm._v(_vm._s(_vm.demographicTitles[demographic] || demographic))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [(_vm.showAudienceChartData(_vm.key, 'filtered').length) ? _c('doughnut-chart', {
      attrs: {
        "height": 120,
        "showLegend": false,
        "data": _vm.audienceProfileData[_vm.key].filtered.map(function (p) { return [p.title, p.show]; })
      }
    }) : _c('doughnut-chart-placeholder')], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [(_vm.showAudienceChartData(demographic, 'total').length) ? _c('doughnut-chart', {
      attrs: {
        "height": 120,
        "showLegend": false,
        "data": _vm.audienceProfileData[demographic].total.map(function (p) { return [p.title, p.show]; })
      }
    }) : _c('doughnut-chart-placeholder')], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [(
      _vm.showAudienceChartData(demographic, 'external').length &&
      _vm.showAudienceChartData(demographic, 'external')[0].length
    ) ? _c('doughnut-chart', {
      attrs: {
        "height": 120,
        "showLegend": false,
        "data": _vm.audienceProfileData[demographic].external.map(function (p) { return [p.title, p.show]; })
      }
    }) : _c('doughnut-chart-placeholder')], 1)])
  })], 2) : _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'AudienceProfileLoader'
    },
    slot: "unit-content"
  })], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Messages",
      "visible": _vm.messagesDialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.messagesDialogVisible = $event
      }
    }
  }, [(!_vm.loadingAudienceData) ? _c('div', [_c('span', [_c('strong', {
    staticClass: "purple"
  }, [_vm._v("Total:")]), _vm._v("\n        " + _vm._s(_vm.formatNumber(_vm.messagesData.total)) + "\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('strong', {
    staticClass: "purple"
  }, [_vm._v("Uniques:")]), _vm._v("\n        " + _vm._s(_vm.formatNumber(_vm.messagesData.uniques)) + "\n      ")])]) : _c('loader', {
    attrs: {
      "message": 'Loading Data'
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f074f934","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/ProgrammingDashboard.vue
// module id = 3422
// module chunks = 3